<template>
  <div class="animated fadeIn">
    <!-- <p class="text-info">連携定義設定</p> -->
    <!-- <b-row>
      <b-col md="6">
        <b-card>
          <div slot="header">
            <strong>この連携定義は</strong>
          </div>
          <b-form-group
            label="有効"
            label-for="integrationValid"
            :label-cols="3"
            :horizontal="true">
            <c-switch id="integrationValid" type="3d" variant="primary" :checked="true"/>
          </b-form-group>
        </b-card>
      </b-col>
    </b-row> -->
    <b-row>
      <b-col md="6">
        <b-card>
          <div slot="header">
            <strong>連携定義 編集</strong>
          </div>
          <b-form-group v-if="integration.IntegrationId == null"
            description="送信元システムを選択してください"
            label="送信元システムID"
            label-for="senderSystemId"
            :label-cols="3"
            :horizontal="true">
            <!--<b-form-select :plain="true" :options="fromSystems" v-model="integration.SenderSystemId">-->
            <!--</b-form-select>-->
            <v-select
              :options="fromSystems"
              v-model="integration.SenderSystemId">
            </v-select>
          </b-form-group>
          <b-form-group v-else
            label="連携定義ID"
            label-for="integrationId"
            :label-cols="3"
            :horizontal="true">
            <b-form-input plaintext id="integrationId" type="text" v-model="integration.IntegrationId"></b-form-input>
          </b-form-group>
          <b-form-group
            description="端的で分かりやすい名前を日本語で付けてください"
            label="連携定義名"
            label-for="integrationName"
            :label-cols="3"
            :horizontal="true">
            <b-form-input id="integrationName" type="text" placeholder="" v-model="integration.IntegrationName"></b-form-input>
          </b-form-group>

          <b-form-group
            label="連携頻度"
            label-for="frequencyNum"
            :label-cols="3"
            :horizontal="true">

          <b-row>
            <b-col sm="2">
                <b-form-select id="frequencyNum" :class="{isInvalid: integration.isInvalidFrequencyNum}"
                  :plain="true"
                  :options="['',1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30]"
                   v-model="integration.frequencyNum">
                </b-form-select>
            </b-col>
            <b-col sm="2">
              <b-form-group>
                <b-form-select id="frequencyUnit"
                  :plain="true"
                  :options="['', 'h', '日', 'ヶ月', '随時']"
                   v-model="integration.frequencyUnit">
                </b-form-select>
              </b-form-group>
            </b-col>
            <!-- <b-col sm="4">
              <b-form-group>
                <b-form-input type="text" id="numinput1" placeholder="123" v-model="integration.frequencyNum"></b-form-input>
              </b-form-group>
            </b-col> -->
          </b-row>

          </b-form-group>

        </b-card>
      </b-col>
    </b-row>

    <b-row>
      <b-col md="6">
        <b-card>
          <div slot="header">
            <strong>連携監視設定</strong>
          </div>

          <b-form-group
            label="監視周期"
            label-for="MonitoringPeriod1"
            :label-cols="3"
            :horizontal="true">

            <b-row>
              <b-col sm="2">
                  <b-form-select id="MonitoringPeriod1" :class="{isInvalid: integration.isInvalidMonitoringPeriod1}"
                    :plain="true"
                    :options="['',1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30]"
                     v-model="integration.MonitoringPeriod1">
                  </b-form-select>
              </b-col>
              <b-col sm="2">
                <b-form-group>
                  <b-form-select id="MonitoringPeriod2"
                    :plain="true"
                    :options="['', 'h', '日', 'ヶ月']"
                    v-model="integration.MonitoringPeriod2">
                  </b-form-select>
                </b-form-group>
              </b-col>

              <b-col sm="3">
                  <label>監視長さ</label>
              </b-col>
              <b-col sm="2">
                <b-form-select id="MonitoringLength1"
                  :plain="true"
                  :options="['',1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30]"
                  v-model="integration.MonitoringLength1">
                </b-form-select>
              </b-col>
              <b-col sm="2">
                <b-form-group>
                  <b-form-select id="MonitoringLength2"
                    :plain="true"
                    :options="['', 'h', '日', 'ヶ月']"
                    v-model="integration.MonitoringLength2">
                  </b-form-select>
                </b-form-group>
              </b-col>

            </b-row>

          </b-form-group>

          <b-form-group
            label="未連携しきい値"
            label-for="MonitoringThreshold"
            :label-cols="3"
            :horizontal="true">

            <b-row>
              <b-col sm="2">
                <b-form-select id="MonitoringThreshold"
                  :plain="true"
                  :options="['',1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30]"
                  v-model="integration.MonitoringThreshold">
                </b-form-select>
              </b-col>
              <b-col sm="2">
              </b-col>

              <b-col sm="8">
                <b-form-group
                  label="監視基準" label-for="MonitoringStartDate"
                  :label-cols="4"
                  :horizontal="true">
                  <b-form-input type="date" id="MonitoringStartDate" v-model="integration.MonitoringStartDate"></b-form-input>
                </b-form-group>
              </b-col>

            </b-row>

          </b-form-group>

          <b-form-group
            label="通知先メールアドレス"
            label-for="MonitoringAlertTo"
            :label-cols="3"
            :horizontal="true">
            <b-form-input id="MonitoringAlertTo" type="text" placeholder="" v-model="integration.MonitoringAlertTo"></b-form-input>
          </b-form-group>

        </b-card>
      </b-col>
    </b-row>

    <b-row>
      <b-col sm="12">
        <b-card header="<strong>送信元設定</strong>">
          <div style="height: 1rem;">
          </div>
          <receive-table hover striped bordered small fixed caption="<strong>送信元設定</strong>"
           ref="child2" :integration="integration" @edit="showEditReceiveFromModal">
          </receive-table>
        </b-card>
      </b-col>
    </b-row>

    <b-row>
      <b-col sm="12">
        <b-card header="<strong>送信先設定</strong>">
          <div>
            <b-button @click="appendSendToModal = true" variant="primary" class="btn-depth pointer">
              <i class="fa fa-plus-circle"></i>&nbsp; 送信先の追加</b-button>
          </div>
          <div style="height: 1rem;">
          </div>
          <c-table hover striped bordered small fixed caption="<strong>送信先設定</strong>"
           ref="child1" :integration="integration" @edit="showEditSendToModal">
          </c-table>
        </b-card>
      </b-col>
    </b-row>

    <b-row>
      <b-col sm="6">
        <b-card>
          <b-row>
            <b-col sm="10">
              <!-- <router-link :to="`/index`"> -->
              <b-button @click="saveConfirmModal = true" variant="primary" class="btn-depth pointer">
                <i class="fa fa-floppy-o"></i>&nbsp; 保存</b-button>
              <!-- </router-link> -->
              <!-- <router-link :to="`/index`"> -->
              <b-button @click="cancelConfirmModal = true" variant="secondary" class="btn-depth pointer">
                <i class="fa fa-undo"></i>&nbsp; キャンセル</b-button>
              <!-- </router-link> -->
            </b-col>
            <b-col sm="2" v-if="integration.IntegrationId">
                <div style="display: inline-block; width: 1rem;">
                </div>
              <b-button @click="delConfirmModal = true" variant="danger" class="btn-depth pointer">
                <i class="fa fa-trash"></i>&nbsp; 削除</b-button>
            </b-col>
          </b-row>
        </b-card>
      </b-col>
    </b-row>

    <!-- Modal Component -->
    <b-modal title="保存" class="modal-primary" v-model="saveConfirmModal" @ok="procSave()">
      保存します。よろしいですか？
    </b-modal>
    <b-modal title="キャンセル" v-model="cancelConfirmModal" @ok="gotoIndexPage()">
      前画面に戻ります。よろしいですか？
    </b-modal>
    <b-modal title="削除" class="modal-danger" v-model="delConfirmModal" @ok="procDel()" ok-variant="danger">
      <div>
        連携定義 {{integration.IntegrationId}} を削除します。
      </div>
      <b-row>
        <b-col md="12">
          <b-card>
            <b-form-group
              description="この操作を行うと S3バケット、SQSキュー、SNS Topicが削除され、連携中のデータを失う可能性があります。リスクを承知の上で削除する場合は、上記に連携定義IDを入力してください。"
              label="削除する連携定義IDを入力"
              label-for="deleteIntegrationId"
              :label-cols="3"
              :horizontal="true">
              <b-form-input id="deleteIntegrationId" type="text" placeholder="" v-model="integration.DeleteIntegrationId"></b-form-input>
            </b-form-group>
          </b-card>
        </b-col>
      </b-row>
    </b-modal>

    <b-modal title="エラー" class="modal-danger" v-model="alertModal" @ok="alertModal = false" ok-variant="danger">
      {{alertContents}}
      <div slot="modal-footer" class="w-100">
        <b-btn size="md" class="float-right" variant="danger" @click="alertModal = false">
          閉じる
        </b-btn>
      </div>
    </b-modal>

    <b-modal size="lg" title="編集" class="modal-primary" v-model="editReceiveFromModal" @ok="procEditReceiveFrom()">
      <b-container fluid>
        <b-row class="mb-1">
          <b-col cols="3">送信元ID</b-col>
          <b-col>
            <vue-simple-suggest
              id="ReceiveFromId"
              v-model="appendingReceiveFrom.ReceiveFromId"
              :list="systemList"
              :filter-by-query="true"
              placeholder="送信元SYSを識別する一意のIDを入力してください"
            />
            <!--<b-form-invalid-feedback v-if="appendingSendToIdValidationMessage.length">-->
            <!--  {{appendingSendToIdValidationMessage}}-->
            <!--</b-form-invalid-feedback>-->
          </b-col>
        </b-row>
        <b-row class="mb-1">
          <b-col cols="3">受信手段</b-col>
          <!--<b-col>{{ appendingReceiveFrom.ReceiveMethod }}</b-col>-->
          <b-col><b-form-select :options="ReceiveMethods" v-model="appendingReceiveFrom.ReceiveMethod" /></b-col>
        </b-row>
        <b-row class="mb-1">
        </b-row>
        <b-row>
          <b-col cols="3">受信パラメータ</b-col>
          <b-col>
            <b-form-textarea :textarea="true" :rows="6"
             v-model="appendingReceiveFrom.ReceiveParams" placeholder="受信パラメータ">
            </b-form-textarea>
            <ul v-if="appendingReceiveFromError.length">
              <li v-for="err in appendingReceiveFromError" :key="err">{{ err }}</li>
            </ul>
          </b-col>
        </b-row>
        <b-row class="mb-1">
        </b-row>
        <b-row class="mb-1">
        </b-row>
      </b-container>
      <div slot="modal-footer" class="w-100">
        <b-btn size="md" class="float-right" style="margin: 0 1rem 0" variant="primary" @click="procEditReceiveFrom()">
          反映する
        </b-btn>
      </div>
    </b-modal>

    <b-modal size="lg" title="追加" class="modal-primary" v-model="appendSendToModal" @ok="procAppendSendTo()">
      <b-container fluid>
        <b-row class="mb-1 text-center">
          <b-col cols="3"> </b-col>
          <b-col></b-col>
        </b-row>
        <!-- <b-row style="height: 1rem;">
        </b-row> -->
        <b-row class="mb-1">
        </b-row>
        <b-row class="mb-1">
          <b-col cols="3">送信先ID</b-col>
          <b-col>
            <vue-simple-suggest
              id="SendToId"
              v-model="appendingSendTo.SendToId"
              :list="systemList"
              :filter-by-query="true"
              placeholder="送信先SYSを識別する一意のIDを入力してください"
            />
            <b-form-invalid-feedback v-if="appendingSendToIdValidationMessage.length">
              {{appendingSendToIdValidationMessage}}
            </b-form-invalid-feedback>
          </b-col>
        </b-row>
        <b-row class="mb-1">
        </b-row>
        <b-row class="mb-1">
          <b-col cols="3">変換モジュールID</b-col>
          <b-col><b-form-select :options="transformationModules" v-model="appendingSendTo.ModuleId" /></b-col>
        </b-row>
        <b-row class="mb-1">
        </b-row>
        <b-row>
          <b-col cols="3">変換パラメータ</b-col>
          <b-col>
            <b-form-textarea id="ModuleParams" :textarea="true" :rows="4"
             v-model="appendingSendTo.ModuleParams" placeholder="変換パラメータ">
            </b-form-textarea>
            <!-- <b-form-input type="text" id="ModuleParams" :textarea="true" :rows="4"
             v-model="appendingSendTo.ModuleParams" placeholder="変換パラメータ">
            </b-form-input> -->
          </b-col>
        </b-row>
        <b-row class="mb-1">
        </b-row>
        <b-row class="mb-1">
          <b-col cols="3">送信手段</b-col>
          <b-col><b-form-select :options="SendMethods" v-model="appendingSendTo.SendMethod" /></b-col>
        </b-row>
        <b-row class="mb-1">
        </b-row>
        <b-row>
          <b-col cols="3">送信パラメータ</b-col>
          <b-col>
            <b-form-textarea id="SendParams" :textarea="true" :rows="6"
             v-model="appendingSendTo.SendParams" placeholder="送信パラメータ">
            </b-form-textarea>
            <!-- <b-form-input type="text" id="SendParams" :textarea="true" :rows="6"
             v-model="appendingSendTo.SendParams" placeholder="送信パラメータ">
            </b-form-input> -->
            <ul v-if="appendingSendtoError.length">
            <li v-for="err in appendingSendtoError" :key="err">{{ err }}</li>
            </ul>
          </b-col>
        </b-row>
        <b-row class="mb-1">
        </b-row>
        <b-row class="mb-1">
        </b-row>
        <!-- <b-row>
          <b-col cols="3">SNS通知</b-col>
          <b-col>
            <b-form-group
              label="要"
              label-for="SnsNotify"
              :label-cols="1"
              :horizontal="true">
              <c-switch id="SnsNotify" type="3d" variant="primary" :checked="appendingSendTo.SnsNotify"/>
            </b-form-group>
          </b-col>
        </b-row> -->
      </b-container>
      <div slot="modal-footer" class="w-100">
        <b-btn size="md" class="float-right" variant="primary" @click="procAppendSendTo()">
          追加する
        </b-btn>
      </div>
    </b-modal>

    <b-modal size="lg" title="編集" class="modal-primary" v-model="editSendToModal" @ok="procEditSendTo()">
      <b-container fluid>
        <b-row class="mb-1 text-center">
          <b-col cols="3"> </b-col>
          <b-col></b-col>
        </b-row>
        <!-- <b-row style="height: 1rem;">
        </b-row> -->
        <b-row class="mb-1">
        </b-row>
        <b-row class="mb-1">
          <b-col cols="3">送信先ID</b-col>
          <b-col>{{appendingSendTo.SendToId}}</b-col>
          <!-- <b-col>
            <b-form-input plaintext type="text" id="SendToId" v-model="appendingSendTo.SendToId"></b-form-input>
          </b-col> -->
        </b-row>
        <b-row class="mb-1">
        </b-row>
        <b-row class="mb-1">
          <b-col cols="3">変換モジュールID</b-col>
          <b-col><b-form-select :options="transformationModules" v-model="appendingSendTo.ModuleId" /></b-col>
        </b-row>
        <b-row class="mb-1">
        </b-row>
        <b-row>
          <b-col cols="3">変換パラメータ</b-col>
          <b-col>
            <b-form-textarea id="ModuleParams" :textarea="true" :rows="4"
             v-model="appendingSendTo.ModuleParams" placeholder="変換パラメータ">
            </b-form-textarea>
            <!-- <b-form-input type="text" id="ModuleParams" :textarea="true" :rows="4"
             v-model="appendingSendTo.ModuleParams" placeholder="変換パラメータ">
            </b-form-input> -->
          </b-col>
        </b-row>
        <b-row class="mb-1">
        </b-row>
        <b-row class="mb-1">
          <b-col cols="3">送信手段</b-col>
          <b-col><b-form-select :options="SendMethods" v-model="appendingSendTo.SendMethod" /></b-col>
        </b-row>
        <b-row class="mb-1">
        </b-row>
        <b-row>
          <b-col cols="3">送信パラメータ</b-col>
          <b-col>
            <b-form-textarea id="SendParams" :textarea="true" :rows="6"
             v-model="appendingSendTo.SendParams" placeholder="送信パラメータ">
            </b-form-textarea>
            <!-- <b-form-input type="text" id="SendParams" :textarea="true" :rows="6"
             v-model="appendingSendTo.SendParams" placeholder="送信パラメータ">
            </b-form-input> -->
            <ul v-if="appendingSendtoError.length">
              <li v-for="err in appendingSendtoError" :key="err">{{ err }}</li>
            </ul>
          </b-col>
        </b-row>
        <b-row class="mb-1">
        </b-row>
        <b-row class="mb-1">
        </b-row>
        <!-- <b-row>
          <b-col cols="3">SNS通知</b-col>
          <b-col>
            <b-form-group
              label="要"
              label-for="SnsNotify"
              :label-cols="1"
              :horizontal="true">
              <c-switch id="SnsNotify" type="3d" variant="primary" :checked="appendingSendTo.SnsNotify"/>
            </b-form-group>
          </b-col>
        </b-row> -->
      </b-container>
      <div slot="modal-footer" class="w-100">
        <b-btn size="md" style="margin: 0 1rem 0" variant="danger" @click="procDelSendTo()">
          削除する
        </b-btn>
        <b-btn size="md" class="float-right" style="margin: 0 1rem 0" variant="primary" @click="procEditSendTo()">
          反映する
        </b-btn>
      </div>
    </b-modal>

  </div>
</template>

<script>
import IntegrationStore from "../../store/integration";
import cSwitch from "../../components/Switch";
import cTable from "../base/TableSendTo.vue";
import receiveTable from "../base/TableReceiveFrom.vue";

import RedPostEnv from "../../resources/redpost-env.json";
import SystemPrefix from "../../resources/system-prefix.json";

import Spinner from "../../components/Spinner";
import InvokeLambda from "../../logic/InvokeLambda";
import GetS3Object from "../../logic/GetS3Object";
import PutS3Object from "../../logic/PutS3Object";
import { createHash } from "crypto";

import { Logger } from "aws-amplify";
import vSelect from 'vue-select';
import VueSimpleSuggest from 'vue-simple-suggest';
import 'vue-simple-suggest/dist/styles.css'; // Optional CSS

const logger = new Logger("Edit");

var confirmOnBeforeRouteLeaveMessage =
  "保存していない情報は破棄されます。移動してもよろしいですか？";
const confirmOnBeforeRouteLeave = (self, to, from, next) => {
  if (confirmOnBeforeRouteLeaveMessage) {
    const answer = window.confirm(confirmOnBeforeRouteLeaveMessage);
    if (answer) {
      next();
    } else {
      next(false);
    }
  } else {
    next();
  }
};

const showAlert = (self, message) => {
  self.alertContents = message;
  self.alertModal = true;
};

const getIntegration = self => {
  if (self.$route.params.id) {
    const id = self.$route.params.id;
    const integrations = IntegrationStore.state.integrations;
    if (integrations && integrations.length > 0) {
      const filtered = integrations.filter(item => item.IntegrationId === id);
      if (filtered.length > 0) {
        // console.dir(filtered)
        return filtered[0];
      }
    }
  }
  self.newIntegration = true;
  return { IntegrationId: null, SendTos: [] };
};

const getOrgIntegrations = self => {
  const org = IntegrationStore.state.integrations;
  return JSON.parse(JSON.stringify(org));
};

// Integration-invokelist.json を 作成
const makeInvokeListJson = integrations => {
  const list = [];
  for (const integration of integrations) {
    const sendTos = [];
    if (integration.SendTos) {
      for (const sendTo of integration.SendTos) {
        let moduleId = "S-4-SendModuleCopyOnly";
        // 変換モジュールIDの「CopyToAnotherAwsBucket」は「CopyOnly」に統合のため削除。
        // 将来的に加工やフィルタを入れるときのためにコメントアウトでソースは残しておく。
        // if (
        //   sendTo.ModuleId &&
        //   sendTo.ModuleId.endsWith("CopyToAnotherAwsBucket")
        // ) {
        //   moduleId = "S-4-SendModuleCopyToAnotherAwsBucket";
        // }
        sendTos.push({
          SendToId: sendTo.SendToId,
          Module: `{'LambdaFunctionName': '${moduleId}'}`
        });
      }
    }
    list.push({ IntegrationId: integration.IntegrationId, SendTos: sendTos });
  }
  return JSON.stringify(list, undefined, 2);
};

// procSaveAndDel
const procSaveAndDel = (self, isDelete) => {
  const body = JSON.stringify(self.orgIntegrations);
  const hash = createHash("sha256")
    .update(body)
    .digest("hex");
  const catalogBucketName = RedPostEnv.env + "-redpost-integration-catalog";
  return GetS3Object.get(catalogBucketName, "catalog.json")
    .then(result => {
      const org = JSON.stringify(result);
      const orgHash = createHash("sha256")
        .update(org)
        .digest("hex");
      if (orgHash !== hash) {
        return Spinner.hide().then(() => {
          showAlert(
            self,
            "他の端末で連携定義カタログファイルが変更されています。"
          );
        });
      }

      self.integration.isInvalidFrequencyNum = false;
      self.integration.isInvalidMonitoringPeriod1 = false;
      self.integration.frequencyNum = self.integration.frequencyNum || "";
      self.integration.frequencyUnit = self.integration.frequencyUnit || "";
      self.integration.MonitoringPeriod1 =
        self.integration.MonitoringPeriod1 || "";
      self.integration.MonitoringPeriod2 =
        self.integration.MonitoringPeriod2 || "";
      self.integration.MonitoringLength1 =
        self.integration.MonitoringLength1 || "";
      self.integration.MonitoringLength2 =
        self.integration.MonitoringLength2 || "";

      // 直接入力しない項目
      self.integration["frequency"] =
        self.integration.frequencyNum + "" + self.integration.frequencyUnit;
      if (self.integration.frequencyUnit === "随時") {
        self.integration["frequency"] = "随時";
        self.integration.frequencyNum = "";
      } else {
        if (self.integration.frequencyUnit && !self.integration.frequencyNum) {
          // self.integration.frequencyNumError = "値を指定してください"
          self.integration.isInvalidFrequencyNum = true;
          return Promise.reject({ validationError: true });
        }
      }

      self.integration["MonitoringPeriod"] =
        self.integration.MonitoringPeriod1 +
        "" +
        self.integration.MonitoringPeriod2;
      if (self.integration.MonitoringPeriod2 === "随時") {
        self.integration["MonitoringPeriod"] = "随時";
        self.integration.MonitoringPeriod1 = "";
      } else {
        if (
          self.integration.MonitoringPeriod2 &&
          !self.integration.MonitoringPeriod1
        ) {
          // self.integration.MonitoringPeriodError = "値を指定してください"
          self.integration.isInvalidMonitoringPeriod1 = true;
          return Promise.reject({ validationError: true });
        }
      }

      self.integration["MonitoringLength"] =
        self.integration.MonitoringLength1 +
        "" +
        self.integration.MonitoringLength2;

      // 監視基準
      // console.dir(self.integration.MonitoringStartDate)

      // self.integration.IntegrationId に一致するものを取得
      const orgItem = result.filter(
        x => x.IntegrationId === self.integration.IntegrationId
      );
      // console.dir(orgItem)
      self.integration["DeleteIntegrationId"] = "";
      let integrations = IntegrationStore.state.integrations;
      if (orgItem && orgItem.length > 0) {
        // 削除
        if (isDelete) {
          self.integration = orgItem[0];
          self.integration["DeleteIntegrationId"] =
            self.integration.IntegrationId;
          // integrations から 削除する連携定義を取り除く
          integrations = integrations.filter(
            x => x.IntegrationId !== self.integration.IntegrationId
          );
        } else {
          // 編集
          // let target = integrations.filter(x => x.IntegrationId === self.integration.IntegrationId)
          for (let target of integrations) {
            if (target.IntegrationId === self.integration.IntegrationId) {
              target = self.integration;
            }
          }
        }
      } else {
        // 新規追加
        if (!self.integration.SenderSystemId) {
          return Spinner.hide().then(() => {
            showAlert(self, "送信元システムIDが選択されていません。");
          });
        }

        let maxNo = 0;
        const existsIntegrations = result.filter(
          x => x.SenderSystemId === self.integration.SenderSystemId
        );
        console.dir(existsIntegrations);
        for (const existsIntegration of existsIntegrations) {
          const currentNo = Number(
            existsIntegration.IntegrationId.replace(
              self.integration.SenderSystemId + "-",
              ""
            )
          );
          const currentNoInt = Number.isNaN(currentNo) ? 0 : currentNo;
          if (maxNo < currentNoInt) {
            maxNo = currentNoInt;
          }
        }
        maxNo++;
        self.integration.IntegrationId =
          self.integration.SenderSystemId + "-" + maxNo;
        integrations.push(self.integration);
      }
      const newBody = JSON.stringify(integrations, undefined, 2);
      return PutS3Object.put(catalogBucketName, "catalog.json", newBody)
        .then(result => {
          // Integration-invokelist.json を put
          const json = makeInvokeListJson(integrations);
          return PutS3Object.put(
            catalogBucketName,
            "Integration-invokelist.json",
            json
          );
        })
        .then(result => {
          // G-4-MutateIntegration Lambdaを呼び出す
          return InvokeLambda.invoke(
            "G-4-MutateIntegration",
            orgItem,
            self.integration
          ).catch(err => {
            console.dir(err);
            return Spinner.hide().then(() => {
              showAlert(
                self,
                "連携定義カタログの更新に伴う AWSリソース作成でエラーが発生しました。"
              );
              // debugger
              // confirmOnBeforeRouteLeaveMessage = ''
              // self.$router.push('/index')
            });
          });
        })
        .then(result => {
          console.dir(result);
          if (result["FunctionError"]) {
            return Spinner.hide().then(() => {
              showAlert(
                self,
                "連携定義カタログの更新に伴う AWSリソース作成でエラーが発生しました。"
              );
            });
          }
          return Spinner.hide().then(() => {
            confirmOnBeforeRouteLeaveMessage = "";
            self.$router.push("/index");
          });
        })
        .catch(err => {
          console.dir(err);
          return Spinner.hide().then(() => {
            showAlert(self, "連携定義カタログの更新に失敗しました。");
            // debugger
            // confirmOnBeforeRouteLeaveMessage = ''
            // self.$router.push('/index')
          });
        });
    })
    .catch(err => {
      console.dir(err);
      if (err.validationError) {
        return Spinner.hide();
      }
      return Spinner.hide().then(() => {
        showAlert(self, "連携定義カタログファイルを読み込むことが出来ません。");
      });
    });
};

export default {
  name: "Edit",
  components: { cSwitch, cTable, receiveTable, vSelect, VueSimpleSuggest },
  data: function() {
    return {
      delConfirmModal: false,
      cancelConfirmModal: false,
      saveConfirmModal: false,
      alertModal: false,
      alertContents: "",
      editReceiveFromModal: false,
      appendingReceiveFrom: {
        ReceiveMethod: "",
        ReceiveParams: "{}",
        ReceiveFromId: ""
      },
      ReceiveMethods: ["agent", "ses-attatch", "CopyFromAnotherAwsBucket", "sftp-put"],
      appendingReceiveFromError: [],
      appendSendToModal: false,
      editSendToModal: false,
      appendingSendTo: {
        SendToId: "",
        ModuleId: "CopyOnly",
        ModuleParams: "{}",
        SendMethod: "agent",
        SendParams: "{}",
        SnsNotify: false
      },
      appendingSendtoError: [],
      appendingSendToIdValidationMessage: "",
      transformationModules: ["CopyOnly"],
      SendMethods: ["agent", "ses-attatch", "CopyToAnotherAwsBucket", "sftp-get"],
      integration: getIntegration(this),
      orgIntegrations: getOrgIntegrations(this),
      newIntegration: false
    };
  },
  watch: {
    "appendingSendTo.ModuleId": function(newValue, oldValue) {
      // appendingSendTo.ModuleId が XXXX の場合は
      // 送信手段の選択肢を「YYYY」のみに限定する
      if (newValue === "XXXX") {
        // 変換モジュールIDが追加されたときのために処理を残している.
        this.SendMethods.splice(
          0,
          this.SendMethods.length,
          "YYYY"
        );
      } else {
        this.SendMethods.splice(
          0,
          this.SendMethods.length,
          "agent",
          "ses-attatch",
          "CopyToAnotherAwsBucket",
          "sftp-get"
        );
      }

      // 選択肢を設定した結果、値が選択肢内に存在しない場合は既定値を設定する
      if (this.SendMethods.indexOf(this.appendingSendTo.SendMethod) < 0) {
        this.appendingSendTo.SendMethod = this.SendMethods[0];
      }
    },
    appendSendToModal: function(newValue, oldValue) {
      // newValueがtrueになったらappendingSendToの中身を一旦リセットする。
      if (newValue) {
        this.resetForm();
      }
    }
  },
  beforeRouteUpdate(to, from, next) {
    // このコンポーネントを描画するルートが変更されたときに呼び出されますが、
    // このコンポーネントは新しいルートで再利用されます。
    // たとえば、動的な引数 `/foo/:id` を持つルートの場合、`/foo/1` と `/foo/2` の間を移動すると、
    // 同じ `Foo` コンポーネントインスタンスが再利用され、そのときにこのフックが呼び出されます。
    // `this` でコンポーネントインスタンスにアクセスできます。
    confirmOnBeforeRouteLeave(this, to, from, next);
  },
  beforeRouteLeave(to, from, next) {
    // このコンポーネントを描画するルートが間もなく
    // ナビゲーションから離れていく時に呼ばれます。
    // `this` でのコンポーネントインスタンスへのアクセスができます。
    confirmOnBeforeRouteLeave(this, to, from, next);
  },
  computed: {
    fromSystems() {
      return SystemPrefix.prefix;
    },
    fromSystemList() {
      const integrations = IntegrationStore.state.integrations;
      let fromSystemList = [];
      for (let integration of integrations) {
        if (integration.ReceiveFroms && integration.ReceiveFroms[0] && integration.ReceiveFroms[0].ReceiveFromId) {
          fromSystemList.push(integration.ReceiveFroms[0].ReceiveFromId);
        }
      }
      // 重複の除去
      fromSystemList = Array.from(new Set(fromSystemList));
      return fromSystemList;
    },
    sendToSystemsList() {
      const integrations = IntegrationStore.state.integrations;
      let sendToSystemsList = [];
      for (let integration of integrations) {
        for (let SendTo of integration.SendTos) {
          sendToSystemsList.push(SendTo.SendToId);
        }
      }
      // 重複の除去
      sendToSystemsList = Array.from(new Set(sendToSystemsList));
      return sendToSystemsList;
    },
    systemList() {
      let systemList = [];
      console.log("fromSystemList=", this.fromSystemList);
      console.log("sendToSystemsList=", this.sendToSystemsList);
      systemList = this.fromSystemList.concat(this.sendToSystemsList);
      // 重複の除去
      systemList = Array.from(new Set(systemList));
      console.log("systemList=", systemList);
      return systemList;
    }
  },
  methods: {
    gotoIndexPage: function() {
      confirmOnBeforeRouteLeaveMessage = "";
      this.$router.push("/index");
    },
    procDel: function() {
      const self = this;
      const integration = self.integration;
      if (integration.DeleteIntegrationId !== integration.IntegrationId) {
        return showAlert(self, "連携定義IDの指定が正しくありません。");
      }
      logger.debug("delete...");
      return procSaveAndDel(self, true);
    },
    procSave: function() {
      const self = this;
      logger.debug("saving...");
      return procSaveAndDel(self, false);
    },
    showEditReceiveFromModal: function(receiveFrom) {
      const self = this;
      self.appendingReceiveFrom = {
        ReceiveMethod: receiveFrom['受信手段'],
        ReceiveParams: receiveFrom['受信パラメータ'],
        ReceiveFromId: receiveFrom['送信元ID']
      };
      self.appendingReceiveFromError.splice(0, self.appendingReceiveFromError.length);
      self.editReceiveFromModal = true;
    },
    showEditSendToModal: function(sendToId) {
      const self = this;
      // フォームの初期化
      this.resetForm();

      // console.dir(sendToId)
      const sendTos = self.integration.SendTos;
      for (const sendTo of sendTos) {
        if (sendToId === sendTo.SendToId) {
          self.appendingSendTo = {
            SendToId: sendToId,
            ModuleId: sendTo.ModuleId,
            ModuleParams: sendTo.ModuleParams,
            SendMethod: sendTo.SendMethod,
            SendParams: sendTo.SendParams,
            SnsNotify: sendTo.SnsNotify
          };
          self.editSendToModal = true;
          return;
        }
      }
      // 渡された送信先IDが見つからない
    },
    checkSendtoParam: function() {
      const self = this;
      let tmpSendParam;

      try {
        JSON.parse(self.appendingSendTo.ModuleParams);
      } catch (e) {
        self.appendingSendtoError.push(
          "変換パラメータのJSONが正しくありません"
        );
      }
      try {
        tmpSendParam = JSON.parse(self.appendingSendTo.SendParams);
      } catch (e) {
        self.appendingSendtoError.push(
          "送信パラメータのJSONが正しくありません"
        );
      }

      if (self.appendingSendtoError.length > 0) {
        // この段階でエラーあるとどうしようもないので終了
        return;
      }

      const mustCheckFilter = key => {
        return !tmpSendParam.hasOwnProperty(key);
      };

      switch (self.appendingSendTo.SendMethod) {
        case "CopyToAnotherAwsBucket":
          const copyToAnotherAwsBucketMust = ["RoleName", "BucketName"];
          const copyToAnotherAwsBucketErr = copyToAnotherAwsBucketMust.filter(
            mustCheckFilter
          );
          if (copyToAnotherAwsBucketErr.length !== 0) {
            self.appendingSendtoError.push(
              `送信手段が${
                self.appendingSendTo.SendMethod
              }の時に送信パラメータとして必要な${copyToAnotherAwsBucketErr.join(
                " と "
              )}が含まれていません`
            );
          }
          break;
        case "ses-attatch":
          const sesAttatchMust = ["Subject", "From", "To"];
          const sesAttatchErr = sesAttatchMust.filter(mustCheckFilter);
          if (sesAttatchErr.length > 0) {
            self.appendingSendtoError.push(
              `送信手段が${
                self.appendingSendTo.SendMethod
              }の時に送信パラメータとして必要な${sesAttatchErr.join(
                " と "
              )}が含まれていません`
            );
          }
          break;
        case "agent":
          // 特にチェック項目はない
          break;
        case "sftp-get":
          // 特にチェック項目はない
          break;
        default:
        // 今後増えた時にチェックを追加する
      }
    },
    procAppendSendTo: function() {
      const self = this;
      this.appendingSendtoError.splice(0, this.appendingSendtoError.length);
      const appendingSendTo = self.appendingSendTo;

      if (!appendingSendTo.SendToId) {
        self.appendingSendtoError.push("送信先IDを指定してください");
      } else if (!appendingSendTo.SendToId.match(/^[a-z0-9-]+$/)) {
        self.appendingSendtoError.push(
          "送信先IDには半角英数（小文字）およびハイフン (-) のみ使用できます"
        );
      } else if (appendingSendTo.SendToId.length > 20) {
        self.appendingSendtoError.push(
          "送信先IDは20文字以内で指定してください"
        );
      } else if (appendingSendTo.SendToId.startsWith("-")) {
        self.appendingSendtoError.push(
          "送信先IDをハイフン (-) で始めることはできません"
        );
      } else if (appendingSendTo.SendToId.endsWith("-")) {
        self.appendingSendtoError.push(
          "送信先IDの末尾をハイフン (-) にすることはできません"
        );
      }

      const sendTos = self.integration.SendTos;

      for (const sendTo of sendTos) {
        if (appendingSendTo.SendToId === sendTo.SendToId) {
          self.appendingSendtoError.push("送信先IDが重複しています");
          // return
        }
      }

      if (!appendingSendTo.ModuleId) {
        self.appendingSendtoError.push("変換モジュールIDを指定してください");
      }

      this.checkSendtoParam();

      // もしエラーがあったら何もしない
      if (self.appendingSendtoError.length !== 0) {
        return;
      }

      sendTos.push({
        SendToId: appendingSendTo.SendToId,
        ModuleId: appendingSendTo.ModuleId,
        ModuleParams: appendingSendTo.ModuleParams,
        SendMethod: appendingSendTo.SendMethod,
        SendParams: appendingSendTo.SendParams,
        SnsNotify: appendingSendTo.SnsNotify
      });

      self.$refs.child1.update();
      self.appendSendToModal = false;
    },
    checkReceiveFromParam: function() {
      const self = this;
      let tmpReceiveParam;
      const appendingReceiveFrom = self.appendingReceiveFrom;

      if (!appendingReceiveFrom.ReceiveFromId) {
        self.appendingReceiveFromError.push("送信元IDを指定してください");
      } else if (!appendingReceiveFrom.ReceiveFromId.match(/^[a-z0-9-]+$/)) {
        self.appendingReceiveFromError.push(
          "送信元IDには半角英数（小文字）およびハイフン (-) のみ使用できます"
        );
      } else if (appendingReceiveFrom.ReceiveFromId.length > 20) {
        self.appendingReceiveFromError.push(
          "送信元IDは20文字以内で指定してください"
        );
      } else if (appendingReceiveFrom.ReceiveFromId.startsWith("-")) {
        self.appendingReceiveFromError.push(
          "送信元IDをハイフン (-) で始めることはできません"
        );
      } else if (appendingReceiveFrom.ReceiveFromId.endsWith("-")) {
        self.appendingReceiveFromError.push(
          "送信元IDの末尾をハイフン (-) にすることはできません"
        );
      }

      try {
        tmpReceiveParam = JSON.parse(self.appendingReceiveFrom.ReceiveParams);
      } catch (e) {
        self.appendingReceiveFromError.push(
          "受信パラメータのJSONが正しくありません"
        );
      }

      if (!appendingReceiveFrom.ReceiveMethod) {
        self.appendingReceiveFromError.push(
          "受信手段が設定されていません"
        );
      }

      if (self.appendingReceiveFromError.length > 0) {
        // この段階でエラーあるとどうしようもないので終了
        return;
      }

      const mustCheckFilter = key => {
        return !tmpReceiveParam.hasOwnProperty(key);
      };

      switch (self.appendingReceiveFrom.ReceiveMethod) {
        case "CopyFromAnotherAwsBucket":
          const copyFromAnotherAwsBucketMust = ["RoleName", "FilePattern"];
          const copyFromAnotherAwsBucketErr = copyFromAnotherAwsBucketMust.filter(
            mustCheckFilter
          );
          if (copyFromAnotherAwsBucketErr.length !== 0) {
            self.appendingReceiveFromError.push(
              `受信手段が${
                self.appendingReceiveFrom.ReceiveMethod
              }の時に受信パラメータとして必要な${copyFromAnotherAwsBucketErr.join(
                " と "
              )}が含まれていません`
            );
          }
          break;
        case "ses-attatch":
          const sesAttatchMust = ["From"];
          const sesAttatchErr = sesAttatchMust.filter(
            mustCheckFilter
          );
          if (sesAttatchErr.length !== 0) {
            self.appendingReceiveFromError.push(
              `受信手段が${
                self.appendingReceiveFrom.ReceiveMethod
              }の時に受信パラメータとして必要な${sesAttatchErr.join(
                " と"
              )}が含まれていません`
            );
          }
          break;
        case "agent":
          // 特にチェック項目はない
          break;
        case "sftp-put":
          // 特にチェック項目はない
          break;
        default:
        // 今後増えた時にチェックを追加する
      }
    },
    procEditReceiveFrom: function() {
      const self = this;
      console.log("procEditReceiveFrom");
      // console.dir(self.integration)
      const appendingReceiveFrom = self.appendingReceiveFrom;

      self.appendingReceiveFromError.splice(0, self.appendingReceiveFromError.length);
      this.checkReceiveFromParam();

      // もしエラーがあったら何もしない
      if (self.appendingReceiveFromError.length !== 0) {
        return;
      }

      self.integration.ReceiveFroms = [
        {
          ReceiveMethod: appendingReceiveFrom.ReceiveMethod,
          ReceiveParams: appendingReceiveFrom.ReceiveParams,
          ReceiveFromId: appendingReceiveFrom.ReceiveFromId
        }
      ];
      self.$refs.child2.update();
      self.editReceiveFromModal = false;
    },
    procEditSendTo: function() {
      const self = this;
      console.log("procEditSendTo");
      // console.dir(self.integration)
      const appendingSendTo = self.appendingSendTo;

      self.appendingSendtoError.splice(0, self.appendingSendtoError.length);
      this.checkSendtoParam();

      // もしエラーがあったら何もしない
      if (self.appendingSendtoError.length !== 0) {
        return;
      }

      const sendTos = self.integration.SendTos;
      for (const sendTo of sendTos) {
        if (appendingSendTo.SendToId === sendTo.SendToId) {
          sendTo.ModuleId = appendingSendTo.ModuleId;
          sendTo.ModuleParams = appendingSendTo.ModuleParams;
          sendTo.SendMethod = appendingSendTo.SendMethod;
          sendTo.SendParams = appendingSendTo.SendParams;
          sendTo.SnsNotify = appendingSendTo.SnsNotify;

          self.$refs.child1.update();
          self.editSendToModal = false;
          return;
        }
      }
    },
    procDelSendTo: function() {
      const self = this;
      console.log("procDelSendTo");
      // console.dir(self.integration)
      self.integration.SendTos = self.integration.SendTos.filter(
        sendTo => self.appendingSendTo.SendToId !== sendTo.SendToId
      );
      self.$refs.child1.update();
      self.editSendToModal = false;
    },
    resetForm: function() {
      const self = this;
      // エラーの初期化
      this.appendingSendtoError.splice(0, this.appendingSendtoError.length);

      // フォームの初期化
      self.appendingSendTo = {
        SendToId: "",
        ModuleId: "",
        ModuleParams: "{}",
        SendMethod: "",
        SendParams: "{}"
      };
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/views/pages/Edit.vue